import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import muiThemeable from 'material-ui/styles/muiThemeable';

import Header from '../Header/Header';
import Navigation from '../Header/Navigation'
import UserList from './UserList';
import UserFormCreate from './UserFormCreate';
import UserFormEdit from './UserFormEdit';
import ImportForm from './ImportForm';
import UpdateBalanceForm from './UpdateBalanceForm'
import UserOrders from './UserOrders'
import {
  NavOuter,
  NavContainer
} from '../Styles/index';

const linkItems = [
  {
    to: "/users",
    text: "User List",
    exact: true
  },
  {
    to: "/users/add",
    text: "Add User"
  },
  {
    to: "/users/import",
    text: "Import Users"
  },
  {
    to: "/users/balanca",
    text: "Update Balance"
  }
];

class Users extends Component {
  render() {
    return (
      <div>
        <Header/>
        <NavOuter bg={this.props.muiTheme.palette.primary2Color}>
          <NavContainer>
            <Navigation height={'36px'} darker items={linkItems}></Navigation>
          </NavContainer>
        </NavOuter>
        <Route exact path="/users" component={UserList}/>
        <Route exact path="/users/add" component={UserFormCreate}/>
        <Route exact path="/users/edit" component={UserFormEdit}/>
        <Route exact path="/users/import" component={ImportForm}/>
        <Route exact path="/users/balanca" component={UpdateBalanceForm}/>
        <Route exact path="/users/:id/orders" component={UserOrders}/>
      </div>
    );
  }
}



export default muiThemeable()(Users);



// WEBPACK FOOTER //
// ./src/components/Users/index.js